import React,{Component,Fragment} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {readtablesforpcl,UpdatePCLentry} from '../actions';
import Wrappercontainer from "../components/Wrappercontainer";
import {Alert, AlertTitle} from "@material-ui/lab";
import { DataGrid } from '@material-ui/data-grid';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  Backdrop, ButtonGroup,
  CircularProgress, Grid, IconButton,
  Snackbar, TextField,
  Typography
} from "@material-ui/core";
import {Cancel,SearchRounded} from '@material-ui/icons';
import AppBarTop from "../components/AppBarTop";
import renderIf from "render-if";
import utils from '../utils';
import Button from "@material-ui/core/Button";
import {CANARY_YELLOW} from "../constants";
//LIST BUFFER
let loadedList = [];
/**
 *
 PCLPROCESSING == DONE OR PENDING OR UNDEFINED IN CASE NOT EXISTING (DEFAULTS TO PENDING)
 PCLUSER == The user who processed the claim
 PCLTIMESTAMP == Timestamp in human readable format when complete is clicked
 PCLCOMMENTS == Comments placed by PCL
 *
 */


const generic_columns = [
  { field: 'PCLPROCESSING', headerName: 'Status',width:125,
    renderCell: (params) => (
      <div style={{width:'100%',height:'100%'}}>
        {renderIf(params.value == 'PENDING' || params.value == undefined || params.value == null)(
          <div style={{width: '100%', height: '100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'black'
            }}>PENDING</Typography>
          </div>)}

        {renderIf(params.value == 'VERIFY' || params.value == undefined || params.value == null)(
          <div style={{width: '100%',backgroundColor:CANARY_YELLOW, height: '100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'white'
            }}>VERIFY</Typography>
          </div>)}

        {renderIf(params.value == 'DONE')(
          <div style={{width: '100%', height: '100%',backgroundColor:'green',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography style={{
              textAlign:'center',
              fontWeight:'600',
              color:'white'
            }}>DONE</Typography>
          </div>)}
      </div>
    )
  },
  { field: 'TYPE', headerName: 'TYPE',width:100   },
  { field: 'BillNo', headerName: 'Bill No' ,width:300  },
  { field: 'BillDate', headerName: 'Bill Date' ,width:150  },
  { field: 'PatientName', headerName: 'Patient Name',width:450  },
  { field: 'TotalOutstanding', headerName: 'Total Outstanding' ,width:200  },
  { field: 'OutstandingDoctorAllocation', headerName: 'Doctor Fees' ,width:150  },
  { field: 'OutstandingHospital', headerName: 'Hospital Fees' ,width:150  }
];



class PCLView extends Component{
  constructor(props) {
    super(props);
    this.state = {
      commentshelpertext:"",commentserror:false,
      searchfield:'',
      width: 0, height: 0,processedValues:[], clinicselection:'',loading:true,showModal:false,link:'',
      totaloutstanding:'',doctoroutstanding:'',hospitaloutstanding:'',drrange:'',comments:'',patientname:"",IPNo:"",BillNo:'',
      showSnackbar:false,snackbarMessage:'',pdfExists:false,BillDate:"",UHID:"",DoctorDisallowedAmount:'',
      disallowedhelpertext:'',disallowederror:false, pclcomments:"",showDialog:false,
      newAllowedRaw:"",newAllowed:"",icdcode:"",scaleofcost:"",supportingdocuments:[],vettingselection:'',
      rowItemContent:{}
    };

  }

  componentDidMount() {
    this.props.readtablesforpcl();
    window.scrollTo(0, 0);
  }


  componentWillReceiveProps(nextProps, nextContext) {

    if(nextProps.clinicdata){
      //List only OPD and EMG
      let newBuff = [];
      nextProps.clinicdata.map((clinicitem,index)=>{
        if(clinicitem.TYPE == 'EMG' || clinicitem.TYPE == 'OPD'){clinicitem.id = index;newBuff.push(clinicitem);}
      })
      loadedList = newBuff;
      this.setState({processedValues:newBuff,loading:false});
    }

    if(Object.values(nextProps.rowreducer).length>0){
      this.setState({loading:false})
      //List only OPD and EMG
      let newBuff = [];
      nextProps.rowreducer.map((clinicitem,index)=>{
        if(clinicitem.TYPE == 'EMG' || clinicitem.TYPE == 'OPD'){clinicitem.id = index;newBuff.push(clinicitem);}
      });
      loadedList = newBuff;
      this.setState({processedValues:newBuff,loading:false});
    }

  }

  /**
   * Handles Row Click
   */
  handleRowClick(e){
    if(e.PCLCOMMENTS){this.setState({pclcomments:e.PCLCOMMENTS})}
    this.setState({rowItemContent:e,showDialog:true});
  }

  searchBills(e){

    let DARNE_BILLNO = 'FOPB/20-21/0000';
    let DARNE_BILLNO2 = 'FSIB/20-21/0000';   //WOPB/20-21/0000 99563
    let WELLKIN_BILLNO = 'WOPB/20-21/0000';

    let BILL = loadedList.find((item)=>item.BillNo === e.target.value)
    if(!BILL){BILL  = loadedList.find((item)=>item.BillNo === DARNE_BILLNO + e.target.value)}
    if(!BILL){BILL  = loadedList.find((item)=>item.BillNo === DARNE_BILLNO2 + e.target.value)}
    if(!BILL){BILL  = loadedList.find((item)=>item.BillNo === WELLKIN_BILLNO + e.target.value)}
    if(BILL){
      let items = [];
      items.push(BILL)
      this.setState({searchfield:e.target.value,processedValues:items });
    }else{
      this.setState({searchfield:e.target.value,processedValues:loadedList});
    }


  }

  updateRow(PCLPROCESSING){
    var _login= "";
    let {clinicname,BillNo} = this.state.rowItemContent;
    if(this.props.auth.data){
      const {login} = this.props.auth.data;
      _login = login;
    }
    let PCL_COMMENTS = this.state.pclcomments;
    if(PCLPROCESSING == 'PENDING'){
      PCL_COMMENTS = ''
    }

    if(PCL_COMMENTS.length == 0 && PCLPROCESSING == 'VERIFY'){
      this.setState({commentshelpertext:"Please enter a comment",commentserror:true});
    }else{
      this.props.UpdatePCLentry(clinicname,BillNo,PCLPROCESSING,_login,utils.getTimeStamp(),PCL_COMMENTS);
      this.setState({loading:true,showDialog:false});
    }
  }

  render() {
    return(
      <Fragment>
        <AppBarTop handleLogout={()=>this.props.history.push("/")}/>
        <Wrappercontainer large>
          <div style={{marginTop:100}}/>


          <TextField
            value={this.state.searchfield}
            onChange={e=>this.searchBills(e)}
            label={'Search by Bill No'}
            style={{margin:10,width:'40%'}}
            variant={'outlined'}/>

          <div style={{ height: '80vh', width: '100%' }}>
          <DataGrid onRowClick={(e)=>this.handleRowClick(e.row)} rows={this.state.processedValues} columns={generic_columns}/>
          </div>
          <Backdrop style={{color:'#fff',zIndex:10000}} open={this.state.loading}>
            <Alert severity={'info'}>
              <div style={{display:'flex',flexDirection:'row'}}>
                <AlertTitle>Please wait ...</AlertTitle>
                <CircularProgress style={{marginLeft:75}} size={20} color={'black'}/>
              </div>
              <strong>Data are being determined</strong>
            </Alert>
          </Backdrop>

          <Snackbar anchorOrigin={{vertical: 'bottom',horizontal: 'right'}}
                    open={this.state.showSnackbar} autoHideDuration={2000}
                    onClose={()=>this.setState({showSnackbar:false})}>
            <Alert onClose={()=>this.setState({showSnackbar:false})} severity={'success'}>
            <AlertTitle>{this.state.snackbarMessage}</AlertTitle>
            </Alert>
          </Snackbar>
        </Wrappercontainer>


        <Dialog fullWidth open={this.state.showDialog}  aria-labelledby="form-dialog-title">
          <Cancel onClick={()=>this.setState({showDialog:false})} style={{height:28,width:28,position:'absolute',top:10,right:10}}/>
          <DialogTitle id="form-dialog-title">Patient Name : {this.state.rowItemContent.PatientName} </DialogTitle>
          <DialogContent>
            <Grid item xs container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography style={{marginTop:5,marginBottom:5,fontWeight:'bold'}}>Bill Type : {this.state.rowItemContent.TYPE}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography style={{marginTop:5,marginBottom:5,fontWeight:'bold'}}>Bill Date : {this.state.rowItemContent.BillDate}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography style={{marginTop:5,marginBottom:5,fontWeight:'bold'}}>Bill Amount : {this.state.rowItemContent.TotalOutstanding}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography style={{marginTop:5,marginBottom:5}}>Doctor Fees : {this.state.rowItemContent.OutstandingDoctorAllocation}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography style={{marginTop:5,marginBottom:5}}>Hospital Fees : {this.state.rowItemContent.OutstandingHospital}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Button onClick={()=>this.updateRow('PENDING')} variant="outlined" color="secondary">reset row</Button>
              </Grid>
            </Grid>

            <TextField style={{marginTop:20,marginBottom:20}}
              autoFocus onChange={e=>this.setState({pclcomments:e.target.value,commentshelpertext:"",commentserror:false})}
              multiline value={this.state.pclcomments}
              helperText={this.state.commentshelpertext}
              error={this.state.commentserror}
              rowsMax={10} variant={'outlined'}
              id="name"
              label="Comments"
              fullWidth
            />

            <ButtonGroup fullWidth disableElevation variant="contained" color="primary" style={{marginBottom:20}}>
              <Button fullWidth variant="contained" style={{backgroundColor:CANARY_YELLOW,color:'white'}} color="primary"
                      onClick={()=>this.updateRow('VERIFY')}>
                verify
              </Button>

              <Button fullWidth variant="contained" color="primary" onClick={()=>this.updateRow('DONE')}>
                Confirm
              </Button>
            </ButtonGroup>
          </DialogContent>

        </Dialog>


      </Fragment>
    )
  }
}

const mapStateToProps = (data) => {
  return data;
}

export default connect(mapStateToProps,{readtablesforpcl,UpdatePCLentry})(withRouter(PCLView));
